import { NgModule } from '@angular/core';
import { BackendModule } from '@freelancer/datastore/core';
import { StoreModule } from '@ngrx/store';
import { adminEnterprisesBackend } from './admin-enterprises.backend';
import { adminEnterprisesReducer } from './admin-enterprises.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('adminEnterprises', adminEnterprisesReducer),
    BackendModule.forFeature('adminEnterprises', adminEnterprisesBackend),
  ],
})
export class DatastoreAdminEnterprisesModule {}
